/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IIntegrationTemplate } from 'app/shared/model/integration-template.model';

export interface ITenantIntegrationTemplate {
  id?: string;
  messageFormat?: string | null;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  template?: IIntegrationTemplate | null;
}

export const defaultValue: Readonly<ITenantIntegrationTemplate> = {
  active: false,
};
